module.exports = __webpack_public_path__ + "circle_gray.ef600.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/circle_gray.svg
// module id = ./src/_asset/sources/assets/images/@svg/circle_gray.svg
// module chunks = main